<template>
  <div id="header">
    <div id="status">
      <h1>&nbsp;</h1>
    </div>
    <div id="globalNav"></div>
    <!-- end globalNav -->
    <div id="logo">
      <img :src="logo" />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    logo() {
      return require("../../../assets/img/logoRightNew.png");
    }
  }
};
</script>

<style scoped>
#header {
  height: 56px;
}

#status {
  height: 34px;
  padding: 0.7em 15px;
  background-color: #000;
  color: #fff;
  border-bottom: 1px solid #fff;
}

#globalNav {
  background: none;
  border: none;
  top: 0;
  width: 56%;
}

#logo {
  position: fixed !important;
  top: 0;
  right: 0;
  width: 84px;
  height: 79px;
  z-index: 100;
}
</style>
